<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

    <b-col>
      <b-form @submit.prevent="saveBemTerceiro">
        <b-card>
          <b-form-row>

            <lg-form-input description="" v-model="form.id" label="ID:*" :disabled="true" />


            <lg-form-input invalidFeedback="A descrição deve ser informado!" description="" v-model="form.descricao"
              label="Descrição:* " />


            <b-col cols="12">
              <lg-finder-page-pessoa  id="finderPessoaCadastroBemTerceiro" @onselect="selectPessoaBemTerceiro"
              v-model="form.pessoa" :label="'Usuário:*'" :prefix="prefix + title + ' >  '" />
            </b-col>

            <lg-form-const-select label="Status:*" v-model="form.situacaoBem" cols="6" sm="6"
              :options="optionsFilterSituacao" />
          </b-form-row>


          <b-form-row>

            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
              <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
                <b-icon icon="check-circle" />
                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

              </b-button>

              <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
                <b-icon icon="x-circle" />
                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

              </b-button>
            </b-col>
            <b-col cols="3"></b-col>

          </b-form-row>




        </b-card>
      </b-form>
    </b-col>
  </b-modal>

</template>


<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import { getDepartamento } from "@/core/auth";

export default {
  components: {
    LgFormConstSelect,
    LgFormInput,
    LgFinderPagePessoa
  },
  props: {
    id: Number,
    ignoreInitialLoad: Boolean,
    prefix: {
      type: String,
      default: "",
    },

  },
  mixins: [FormResourceMixin],

  data() {
    return {
      title: " Cadastro",
      showModal: true,
      form: {
        id: null,
        pessoa: {nome: ''},
        descricao: "",
        departamento: getDepartamento(),
        situacaoBem: 1,
      },
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: 1 },
        { key: "filterSituacao", text: "Inativo", value: 0 },
      ],

    };
  },

  async beforeMount() {
    this.$service = new ResourceService(`/api/bemterceiro`);
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form.pessoa.nome = data.pessoa.nome;
      this.form.pessoa.id = data.pessoa.id;

      this.form.situacaoBem = data.situacaoBem;
      this.form.descricao = data.descricao;
      this.form.id = data.id;

    }

  },

  methods: {
    selectPessoaBemTerceiro(pessoa) {
      this.form.pessoa = pessoa;
    },
    cancelar() {
      this.$emit("close");
    },

    async save() {

      if (!this.form.descricao || this.form.descricao.length == 0 || (!this.form.pessoa || !this.form.pessoa.id)) {
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        });
        return;
      }


      await this.$saveResource(this.form, "", false);

      this.cancelar();

    },
  },
};
</script>
